module.exports = __webpack_public_path__ + "static/img/aboutbanner.b0bc525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/aboutbanner.png
// module id = RZVH
// module chunks = 1